import React from 'react';
import { useNotify } from 'react-admin';
import { getGateSchedule, getPortsList, SaveApiResMessage } from '@/actions';
import List from './List';
import styles from './styles';
import Pagination from '@/components/pagination';
import Add from './Add';
import ListAdmin from './ListAdmin';
import LoadingV2 from '@/components/Loading';

export default (props) => {
  const cls = styles();
  const notify = useNotify();
  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    pages: [],
  });
  const [loading, setLoading] = React.useState(true);
  const [DATATable, setDataTable] = React.useState({});
  const [PortsList, setPortsList] = React.useState({});
  const [PortId, setPortId] = React.useState(null);
  const [filter, setFilter] = React.useState({
    open: false,
    DATA: [],
  });

  // Format the date to separate day, abbreviated month, and year
  function formatDate(date, format) {
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const dayName = dayNames[date.getDay()];
    const monthNumber = String(monthIndex + 1).padStart(2, '0'); // Add leading zero if necessary
    const month = monthNames[monthIndex];
    if (format == 1) {
      return `${year}-${monthNumber}-${day}`;
    } else {
      return { day, dayName, monthNumber, month, year };
    }
  }

  // Print the dates of the current week
  function getCurrentWeekDates() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startDate = new Date(today);
    startDate.setDate(startDate.getDate() - dayOfWeek);
    const weekDates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + i);
      weekDates.push(date);
    }
    return weekDates;
  }

  const weekDates = getCurrentWeekDates();
  const formattedCurrentWeekDates = weekDates.map((date) =>
    formatDate(date, 1)
  );

  const getGateScheduleList = () => {
    setLoading(true);
    getGateSchedule(
      formattedCurrentWeekDates[0],
      formattedCurrentWeekDates[6],
      PortId
    )
      .then((res) => {
        if (res) {
          setDataTable(res.data.schedule);
        }
        let keys = Object.keys(DATATable);

        if (keys.length > 0) {
          setLoading(false);
        }
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  const getPortsListFanc = () => {
    setLoading(true);
    getPortsList()
      .then((res) => {
        setPortsList(Object.values(res.data.ports).map((ports) => ports));
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  React.useEffect(() => {
    getGateScheduleList();
    getPortsListFanc();
  }, [pagination.currentPage]);
  return (
    <div id="inventoryEmpty" className={cls.content}>
      <div className={cls.cardHeader}>
        <span className={cls.title}>Gate Schedule Setting</span>
        <span>
          <span className={cls.title}>Export</span>
          <span
            className={cls.titleBlue}
            // onClick={handleExport}
          >
            XLSX
          </span>
        </span>
      </div>

      {/* <Add
        notify={notify}
        DATATable={DATATable}
        PortsList={PortsList}
        startDate={formattedCurrentWeekDates[0]}
        endDate={formattedCurrentWeekDates[6]}
        setData={(res) => {
          setFilter({ ...filter, DATATable });
        }}
      /> */}

      {/* <Filter
          title="Gate Schedule"
          filter={filter}
          setFilter={setFilter}
          DATA={DATATable}>
          <span className={cls.title}>Export</span>
          <span
            className={cls.titleBlue}
            // onClick={handleExport}
          >
            XLSX
          </span>
        </Filter> */}

      {loading ? (
        <div className="mt-16">
          <LoadingV2 />
        </div>
      ) : (
        <ListAdmin
          DATA={DATATable}
          TerminalsList={DATATable}
          PortsList={PortsList}
        />
      )}
    </div>
  );
};
